import React, { useState } from 'react'
import PageTitle from '../Utilities/PageTitle'
import { Link } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from 'axios';

export default function Contact(props) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const customStyles = {
        content: {
            top: '0',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            // transform: 'translate(-50%, -50%)',
        },
    };
    //  all values

    const [nameValue, setNameValue] = useState();
    const [email, setEmail] = useState();
    const [organization, setOrganization] = useState();
    const [position, setPosition] = useState();
    const [phone, setPhone] = useState();

    const [submitMsg, setSubmitMsg] = useState('');
    const [message, setMessage] = useState('');

    async function submitForm(e) {
        e.preventDefault();
        const bodyFormData = new FormData();

        bodyFormData.append('name', nameValue);
        bodyFormData.append('email', email);
        bodyFormData.append('position', position);
        bodyFormData.append('organization', organization);
        bodyFormData.append('message', message);
        bodyFormData.append('phone', phone);

        const response = await axios.post(`https://saudigermanacademy.com/Aadm25/api/mwforms/contact_us`, bodyFormData)
            .then(response => {
                // console.log(branchValue);
                // Handle the response
                if (response.data.Ecode === 200) {
                    // setCheckPhoneNum(response.data.Emsg);
                    console.log(response.data);
                    // handleShow();
                    if (response.data.Edata.request_id > 0) {
                        setSubmitMsg('Thank You!')
                        setMessage("Your form has been submitted successfully. We'll be in touch shortly.")
                    } else {
                        setSubmitMsg('Oppssss!! please Check Your Data ')

                    }

                    handleShow();

                }

            })
            .catch(error => {
                // Handle any errors
                console.error(error);
            });

    }
    const resetForm = () => {
        setNameValue('');
        setEmail('');
        setPosition('');
        setPhone('');
        setOrganization('');
        setMessage('');
    };
    return <>


        {/* <!-- Start main-content --> */}
        <div className="main-content-area">
            <PageTitle title='Contact Us' homeLink='/' homePage='Home' currentLink='/contact-us' />
            {/* <!-- Section: Contact Form --> */}
            <section id="contact" className="bg-white-f4">
                <div className="container py-md-5 py-4">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-lg-6">
                                <h5 className="mb-0 text-gray">Happy to help!</h5>
                                <h2 className="mb-30">If you need someone to talk to, we listen. We won’t judge or tell you what to do.</h2>
                                <div className="icon-box icon-left iconbox-centered-in-responsive iconbox-theme-colored1 animate-icon-on-hover animate-icon-rotate mb-50">
                                    <div className="icon-box-wrapper">
                                        <div className="icon-wrapper">
                                            <Link className="icon icon-type-font-icon icon-dark icon-circled"> <i className="flaticon-contact-044-call-1"></i> </Link>
                                        </div>
                                        <div className="icon-text">
                                            <h5 className="icon-box-title mt-0">Hotline</h5>
                                            <div className="content"><Link to="tel:+16259">+16259</Link></div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="icon-box icon-left iconbox-centered-in-responsive iconbox-theme-colored1 animate-icon-on-hover animate-icon-rotate mb-50">
                                    <div className="icon-box-wrapper">
                                        <div className="icon-wrapper">
                                            <Link className="icon icon-type-font-icon icon-dark icon-circled"> <i className="flaticon-contact-043-email-1"></i> </Link>
                                        </div>
                                        <div className="icon-text">
                                            <h5 className="icon-box-title mt-0">Email</h5>
                                            <div className="content"><Link to="mailto:info@saudigermanacademy.com">info@saudigermanacademy.com</Link></div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <div className="icon-box icon-left iconbox-centered-in-responsive iconbox-theme-colored1 animate-icon-on-hover animate-icon-rotate mb-50">
                                    <div className="icon-box-wrapper">
                                        <div className="icon-wrapper">
                                            <Link className="icon icon-type-font-icon icon-dark icon-circled"> <i className="flaticon-contact-025-world"></i> </Link>
                                        </div>
                                        <div className="icon-text">
                                            <h5 className="icon-box-title mt-0">Address</h5>
                                            <div className="content">47,Josef Teto street - Nozha, Heliopolis, Cairo, Egypt</div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                <ul className="styled-icons icon-dark icon-sm icon-circled mt-30">
                                    <li><Link to="https://www.facebook.com/SGHAcademy?mibextid=9R9pXO" data-tm-bg-color="#3B5998" style={{ backgroundColor: '#3B5998' }}><i className="fab fa-facebook"></i></Link></li>
                                    <li><Link to="https://www.linkedin.com/company/saudigermanacademy/" data-tm-bg-color="#4C75A3" style={{ backgroundColor: '#4C75A3' }}><i className="fab fa-linkedin"></i></Link></li>
                                    <li><Link to="https://www.instagram.com/sghacademy/?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D" data-tm-bg-color="#D9CCB9" style={{ backgroundColor: '#D9CCB9' }}><i className="fab fa-instagram"></i></Link></li>
                                    <li><Link to="" data-tm-bg-color="#D71619" style={{ backgroundColor: '#D71619' }}><i className="fab fa-youtube"></i></Link></li>

                                </ul>
                            </div>
                            <div className="col-lg-6">
                                <h2 className="mt-0 mb-0">Interested in discussing?</h2>
                                <p className="font-size-20">Active & Ready to use Contact Form!</p>
                                {/* <!-- Contact Form --> */}
                                <form name="contact_form" onSubmit={submitForm} method="post">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="mb-3">
                                                <label>Name <small>*</small></label>
                                                <input name="form_name" className="form-control" type="text" placeholder="Enter Name" value={nameValue} onChange={(e) => setNameValue(e.target.value)} required />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="mb-3">
                                                <label>Email <small>*</small></label>
                                                <input name="form_email" className="form-control required email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Enter Email" required />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="mb-3">
                                                <label>Position <small>*</small></label>
                                                <input name="form_position" className="form-control required" value={position} onChange={(e) => setPosition(e.target.value)} type="text" placeholder="Enter Position" required />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="mb-3">
                                                <label>Phone</label>
                                                <input name="form_phone" className="form-control" type="number" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Enter Phone" required />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="mb-3">
                                            <label>Organization <small>*</small></label>
                                            <input name="form_organization" className="form-control required" value={organization} onChange={(e) => setOrganization(e.target.value)} type="text" placeholder="Enter Organization" required />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label>Message</label>
                                        <textarea name="form_message" className="form-control required" value={message} onChange={(e) => setMessage(e.target.value)} rows="5" placeholder="Enter Message" required></textarea>
                                    </div>
                                    <div className="mb-3">
                                        <input name="form_botcheck" className="form-control" type="hidden" />
                                        <button type="submit" className="btn btn-flat btn-theme-colored1 text-uppercase mt-10 mb-sm-30 border-left-theme-color-2-4px" data-loading-text="Please wait..." >Send your message</button>
                                        <button type="reset" className="btn btn-flat btn-theme-colored3 text-uppercase mt-10 mb-sm-30 border-left-theme-color-2-4px" onClick={resetForm}>Reset</button>
                                    </div>
                                </form>


                            </div>
                            <div className="col-sm-12 text-center">

                                <Modal   {...props}
                                    size="lg"
                                    style={customStyles}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered show={show} onHide={handleClose} className="top-0 ">

                                    <Modal.Header closeButton>
                                        <img className="" src='/images/cropped-9952-img-32x32.jpg' alt="" />

                                        <Modal.Title className='text-theme-colored2 fw-bold'>Contact Us</Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body>
                                        <div className="team-member text-center">
                                            <div className="team-description pt-0">
                                                <h3><Link>{submitMsg}</Link></h3>
                                                <p className='lead fw-light'>{message}</p>
                                            </div>



                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button className='btn btn-theme-colored2 btn-sm appoint-btn mt-3 mt-sm-0' variant="secondary" onClick={handleClose}>
                                            Close
                                        </Button>

                                    </Modal.Footer>

                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- End Divider --> */}

            {/* <!-- Section: Contact --> */}
            <section>
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-md-12">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d55224.820293139404!2d31.2842215!3d30.10703530000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sJosef%20Teto%20Street%2C%20Nozha%2C%20Heliopolis%2C%20Cairo%2C%20Egypt!5e0!3m2!1sen!2seg!4v1689075257922!5m2!1sen!2seg" width="100%" height="450" style={{ border: "0" }} allowfullscreen="" loading="lazy" title='map' referrerpolicy="no-referrer-when-downgrade"></iframe>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    </>
}
